import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map } from 'rxjs';
import { UtilsService } from 'src/app/utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class WsFooterService {

  constructor(private httpClient: HttpClient) { }

  /**
  * Api to addSubscribe email
  * @returns 
  */
  addSubscribe(subscribeDetail: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<any>(UtilsService.BASE_URL + UtilsService.ADDSUBSCRIBER, subscribeDetail, httpOptions)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }
}
